import { List, Typography } from '@mui/material';

import BoxIcon from '@/components/Icons/BoxIcon';
import CpuIcon from '@/components/Icons/CpuIcon';
import HomeIcon from '@/components/Icons/HomeIcon';
import LinkIcon from '@/components/Icons/LinkIcon';
import ToolIcon from '@/components/Icons/ToolIcon';
import { BasetenPageEnum } from '@/routes';

import { WorkspaceSections } from '../../types';
import { AppLink, MenuItem } from '../styled';
import { Section } from './styled';
import { NavigationProps } from './types';

function Navigation({ selectedSection }: NavigationProps) {
  return (
    <List>
      <Section>
        <MenuItem selected={selectedSection === WorkspaceSections.Overview}>
          <AppLink
            page={BasetenPageEnum.Workspace}
            params={{
              section: WorkspaceSections.Overview,
            }}
          >
            <HomeIcon
              color={selectedSection === WorkspaceSections.Overview ? 'inherit' : 'secondary'}
            />{' '}
            Overview
          </AppLink>
        </MenuItem>
      </Section>
      <Section>
        <Typography variant="h6" color="text.muted" sx={{ mb: 1.5 }}>
          Dedicated deployments
        </Typography>

        <MenuItem
          data-cy="sidebar-models-link"
          selected={selectedSection === WorkspaceSections.Models}
        >
          <AppLink
            page={BasetenPageEnum.Workspace}
            params={{
              section: WorkspaceSections.Models,
            }}
          >
            <CpuIcon
              color={selectedSection === WorkspaceSections.Models ? 'inherit' : 'secondary'}
            />{' '}
            Models
          </AppLink>
        </MenuItem>
        <MenuItem
          data-cy="sidebar-chains-link"
          selected={selectedSection === WorkspaceSections.Chains}
        >
          <AppLink
            page={BasetenPageEnum.Workspace}
            params={{
              section: WorkspaceSections.Chains,
            }}
          >
            <LinkIcon
              color={selectedSection === WorkspaceSections.Chains ? 'inherit' : 'secondary'}
            />
            Chains
          </AppLink>
        </MenuItem>
      </Section>
      <Section>
        <MenuItem
          data-cy="sidebar-model-apis-link"
          selected={selectedSection === WorkspaceSections.ModelAPIs}
        >
          <AppLink
            page={BasetenPageEnum.Workspace}
            params={{
              section: WorkspaceSections.ModelAPIs,
            }}
          >
            <BoxIcon
              color={selectedSection === WorkspaceSections.ModelAPIs ? 'inherit' : 'secondary'}
            />{' '}
            Model APIs
          </AppLink>
        </MenuItem>
        <MenuItem
          data-cy="sidebar-training-link"
          selected={selectedSection === WorkspaceSections.Training}
        >
          <AppLink
            page={BasetenPageEnum.Workspace}
            params={{
              section: WorkspaceSections.Training,
            }}
          >
            <ToolIcon
              color={selectedSection === WorkspaceSections.Training ? 'inherit' : 'secondary'}
            />{' '}
            Training
          </AppLink>
        </MenuItem>
      </Section>
    </List>
  );
}

export default Navigation;
